export const ImageData = [
  {
    id: "Zola",
    serverID: 10,
    position: { top: "130px", left: "128px" },
    size: "1",
    linkPosition: { top: "177px", left: "107px", paddingLeft: "20px" },
  },
  {
    id: "Shahrchai",
    serverID: 9,
    position: { top: "366px", left: "220px" },
    size: "2",
    linkPosition: { top: "419px", left: "225px", paddingLeft: "10px" },
  },
  {
    id: "Hasanlu",
    serverID: 4,
    position: { top: "490px", left: "430px" },
    size: "1",
    linkPosition: { top: "548px", left: "415px", paddingLeft: "15px" },
  },
  {
    id: "Mahabad",
    serverID: 5,
    position: { top: "712px", left: "525px" },
    size: "2",
    linkPosition: { top: "767px", left: "523px", paddingLeft: "13px" },
  },
  {
    id: "Derik Salmas",
    serverID: 7,
    position: { top: "68px", left: "307px" },
    size: "0",
    linkPosition: { top: "102px", left: "286px" },
  },
  {
    id: "Bukan",
    serverID: 2,
    position: { top: "775px", left: "749px" },
    size: "3",
    linkPosition: { top: "863px", left: "769px", paddingLeft: "18px" },
  },
  {
    id: "Nahand",
    serverID: 6,
    position: { top: "152px", left: "838px" },
    size: "0",
    linkPosition: { top: "185px", left: "810px", paddingLeft: "12px" },
  },
  {
    id: "Tajyar Sarab",
    serverID: 11,
    position: { top: "77px", left: "1061px" },
    size: "0",
    linkPosition: { top: "109px", left: "1038px" },
  },
  {
    id: "KurdKandi",
    serverID: 12,
    position: { top: "237px", left: "1007px" },
    size: "0",
    linkPosition: { top: "269px", left: "981px" },
  },
  {
    id: "Ajabshir GhaleChai",
    serverID: 3,
    position: { top: "345px", left: "1120px" },
    size: "1",
    linkPosition: { top: "386px", left: "1075px", width: "130px" },
  },
  {
    id: "Alavian",
    serverID: 1,
    position: { top: "418px", left: "1058px" },
    size: "1",
    linkPosition: { top: "457px", left: "1042px", paddingLeft: "10px" },
  },
  {
    id: "Sarough(Gogerdchi)",
    serverID: 8,
    position: { top: "823px", left: "1110px" },
    size: "0",
    linkPosition: {
      top: "857px",
      left: "1080px",
      width: "119px",
      // fontSize: '8px',
      padding: "0 0 0 2px",
      // transformOrigin: 'center left',
      // transform: 'scale(0.96)',
    },
  },
];

export const Stations = [
  { serverID: 16, id: "Daryan", position: { top: "89px", left: "450px" } },
  {
    serverID: 15,
    id: "Yalghuz Aghaj",
    position: { top: "132px", left: "445px", width: "99px"},
  },
  {
    serverID: 14,
    id: "Abajalu sofla",
    position: { top: "229px", left: "463px" },
  },
  { serverID: 13, id: "Pol Ozbak", position: { top: "304px", left: "474px" } },
  { serverID: 12, id: "Keshtiban", position: { top: "388px", left: "510px" } },
  { serverID: 11, id: "Babarud", position: { top: "446px", left: "509px" } },
  {
    serverID: 10,
    id: "Pol-e-Bahramlu",
    position: { top: "566px", left: "505px", paddingLeft: "5px" },
  },
  { serverID: 9, id: "Gerd Yaqub", position: { top: "648px", left: "476px" } },
  { serverID: 8, id: "Rasoul Abad", position: { top: "613px", left: "626px" } },
  {
    serverID: 7,
    id: "Nezam Abad",
    position: { top: "554px", left: "708px", paddingLeft: "9px" },
  },
  { serverID: 6, id: "Dash Band", position: { top: "553px", left: "885px" } },
  { serverID: 5, id: "Pol-e-Bonab", position: { top: "420px", left: "800px" } },
  { serverID: 4, id: "Shishvan", position: { top: "344px", left: "807px" } },
  {
    serverID: 3,
    id: "Pol Azarshahr",
    position: { top: "275px", left: "669px", paddingLeft: "7px" },
  },
  { serverID: 2, id: "Khor Khor", position: { top: "187px", left: "669px" } },
  { serverID: 1, id: "Pol-sinikh", position: { top: "91px", left: "725px" } },
];

const LakeD = {
  lake: {
    volume: "حجم فعلی",
    pre_volume: "حجم روز مشابه در سال قبل",
    area: (
      <span>
        سطح فعلی (km <sup>2</sup>)
      </span>
    ),
    pre_area: "سطح روز مشابه در سال قبل",
    level: "تراز فعلی (m)",
    pre_level: "تراز روز مشابه در سال قبل",
  },
  input: {
    total_input: "مجموع ورودی به دریاچه از ابتدای سال آبی",
    pre_total_input:
      "مجموع ورودی به دریاچه از ابتدای سال آبی تا روز مشابه در سال قبل",
  },
  evaporation: { value: "تبخیر مجموع ورودی به دریاچه از ابتدای سال آبی" },

  leftOvers: [
    {
      title: "کمترین تراز مشاهده شده",
      value: 1270.04,
      possible: "min_level",
      date: "1394/7/1",
    },
    { title: "تراز اکولوژیک", value: 1274.1 },
    { title: "حداقل تراز بستر", value: 1269.03 },
    {
      title: "میانگین بلند مدت 20 ساله مجموع ورودی به دریاچه از ابتدای سال آبی",
      value: 0,
    },
    {
      title:
        "تبخیر مجموع ورودی به دریاچه از ابتدای سال آبی تا روز مشابه در سال قبل",
      value: 0,
    },
  ],
};

const DamD = {
  real: {
    // cur_drinking_usage: null,
    // cur_farmin_usage: null,
    // cur_industrial_usage: null,
    // cur_input: null,
    // cur_other_usage: null,
    // cur_output: null,
    // cur_volume: null,
    // drinking_usage_worst_year: 0.7668145748094254,
    // farming_usage_worst_year: 0.8756935128070652,
    // fullness_percentage: 57.61597523409603,
    // industrial_usage_worst_year: 0.8616309823183147,
    // other_usage_worst_year: 0.611474094606908,
    // pre_drinking_usage: null,
    // pre_farming_usage: null,
    // pre_industrial_usage: null,
    // pre_input: null,
    // pre_other_usage: null,
    // pre_output: null,
    // pre_volume: null,

    total_input: "مجموع ورودی",
    total_input_pre: "مجموع ورودی سال گذشته",
    // full_percentage: 'درصد پر بودن مخازن',
    fullness_percentage: "درصد پر بودن مخازن",
    farming_usage: "مجموع مصارف کشاورزی",
    drinking_usage: "مجموع مصارف شرب",
    industrial_usage: "مجموع مصارف صنعت",
    other: "رها سازی دریاچه ارومیه",
    farming_usage_pre: "مجموع مصارف کشاورزی در سال گذشته",
    drinking_usage_pre: "مجموع مصارف شرب در سال گذشته",
    industrial_usage_pre: "مجموع مصارف صنعت در سال گذشته",
    other_pre: "رها سازی دریاچه ارومیه در سال گذشته",
    volume: "حجم مخازن",
    volume_pre: "حجم مخازن سال گذشته",
    farming_usage_worst_year: "مجموع مصارف کشاورزی در بدترین سال آبی",
    drinking_usage_worst_year: "مجموع مصارف شرب در بدترین سال آبی",
    industrial_usage_worst_year: "مجموع مصارف صنعت در بدترین سال آبی",
    other_usage_worst_year: "رهاسازی دریاچه در بدترین سال آبی",
  },

  program: {
    farming_usage: "برنامه مجموع مصارف کشاورزی",
    drinking_usage: "برنامه مجموع مصارف شرب",
    industrial_usage: "برنامه مجموع مصارف صنعت",
    other: "برنامه رهاسازی دریاچه ارومیه",
  },
};

const WatershedD = {
  evaporation: { value: "تبخیر و تعرق (Dakadal-mm)" },
  rainfall: {
    annually: "مجموع بارش از ابتدای سال آبی (mm)",
    total_mean: "میانگین بلند مدت 52 ساله مجموع بارش تا روز مشابه (mm)",
    last_year: "مجموع بارش تا روز مشابه در سال آبی قبل (mm)",
    worst_year: "مجموع بارش تا روز مشابه در بدترین سال آبی (mm)",
  },
  leftOvers: [
    { title: "مجموع بارش از ابتدای سال آبی (mm)", value: 0 },
    {
      title: "میانگین بلند مدت 52 ساله مجموع بارش تا روز مشابه (mm)",
      value: 0,
    },
    { title: "مجموع بارش تا روز مشابه در سال آبی قبل (mm)", value: 0 },
    { title: "مجموع بارش تا روز مشابه در بدترین سال آبی (mm)", value: 0 },
  ],
};

export const DataD = { Dam: DamD, Watershed: WatershedD, Lake: LakeD };

export const upperviewD = {
  real: [
    "industrial_usage",
    "farming_usage",
    "drinking_usage",
    "other",

    "industrial_usage_pre",
    "farming_usage_pre",
    "drinking_usage_pre",
    "other_pre",

    "industrial_usage_worst_year",
    "farming_usage_worst_year",
    "drinking_usage_worst_year",
    "other_usage_worst_year",
  ],
  program: ["industrial_usage", "farming_usage", "drinking_usage", "other"],
};
